import React, { useState, useEffect } from 'react';

import { APIROOT } from '../../Helpers/configs';
import { GetAuth } from '../../Auth/AuthProvider';

import GlobalNotes from '../CommonComponents/GlobalNotes';

import {
  Box,
  Button,
  Grid,
  Typography,
  Divider,
  Checkbox,
  TextField,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import { ticketTypoTitle, ticketTypoInfo } from '../shared/commonStyle';

const BillingNoteRepair = (props) => {
  const closeModal = props.closeModel;
  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function
  const [forceUpdate, setForceUpdate] = useState(1);

  const ticketData = props.ticketData;
  const relationId = props.relationId;

  const [timeData, setTimeData] = useState({
    nt_minutes: 0,
    ot1_minutes: 0,
    ot2_minutes: 0,
  });

  const ticketID = ticketData['repair-ticket'].id || '';
  const [billingData, setBillingData] = useState([]);

  const [jc_stamped, set_jc_stamped] = useState('');
  const [so_stamped, set_so_stamped] = useState('');
  const [grn_used, set_grn_used] = useState('');
  const [hw_permit, set_hw_permit] = useState('');
  const [COC, set_COC] = useState('');
  const [comp_sheet, set_comp_sheet] = useState(billingData.comp_sheet || '');
  const [WO, set_WO] = useState(billingData.WO || '');

  const [t_customerRating, set_t_customerRating] = useState('');

  const [t_travelKM, set_t_travelKM] = useState('');

  const [t_travelTimeNT, set_t_travelTimeNT] = useState('');
  const [t_travelTimeOT1, set_t_travelTimeOT1] = useState('');
  const [t_travelTimeOT2, set_t_travelTimeOT2] = useState('');

  const [s_invoiceStore, set_s_invoiceStore] = useState(
    billingData.s_invoiceStore || false
  );
  const [s_warrantee, set_s_warrantee] = useState(
    billingData.s_warrantee || false
  );
  const [s_claimSupplier, set_s_claimSupplier] = useState(
    billingData.s_claimSupplier || false
  );
  const [s_noCharge, set_s_noCharge] = useState(
    billingData.s_noCharge || false
  );
  const [s_reCall, set_s_reCall] = useState(billingData.s_reCall || false);
  const [t_QNumber, set_t_QNumber] = useState('');
  const [t_CONumber, set_t_CONumber] = useState('');
  const [t_INumber, set_t_INumber] = useState('');
  const [t_IAmount, set_t_IAmount] = useState('');
  const [t_tripSplit1, set_t_tripSplit1] = useState('');
  const [t_tripSplit2, set_t_tripSplit2] = useState('');
  const [t_accAndSnt, set_t_accAndSnt] = useState('');
  const [t_ticketNR, set_t_ticketNR] = useState('');
  const [t_WHTransfer, set_t_WHTransfer] = useState('');
  const [t_WONumber, set_t_WONumber] = useState('');
  const [t_SONumber, set_t_SONumber] = useState('');
  const [t_GRNNumber, set_t_GRNNumber] = useState('');

  useEffect(() => {
    let data = billingData;
    set_jc_stamped(data.jc_stamped);
    set_so_stamped(data.so_stamped);
    set_grn_used(data.grn_used);
    set_hw_permit(data.hw_permit);
    set_COC(data.COC);
    set_comp_sheet(data.comp_sheet);
    set_WO(data.WO);
    set_t_customerRating(data.t_customerRating);
    set_t_travelKM(data.t_travelKM);
    set_t_travelTimeNT(data.t_travelTimeNT);
    set_t_travelTimeOT1(data.t_travelTimeOT1);
    set_t_travelTimeOT2(data.t_travelTimeOT2);
    set_t_QNumber(data.t_QNumber);
    set_t_CONumber(data.t_CONumber);
    set_t_INumber(data.t_INumber);
    set_t_IAmount(data.t_IAmount);
    set_t_tripSplit1(data.t_tripSplit1);
    set_t_tripSplit2(data.t_tripSplit2);
    set_s_noCharge(data.s_noCharge);
    set_s_reCall(data.s_reCall);
    set_s_invoiceStore(data.s_invoiceStore);
    set_s_warrantee(data.s_warrantee);
    set_s_claimSupplier(data.s_claimSupplier);
    set_t_accAndSnt(data.t_accAndSnt);
    set_t_ticketNR(data.t_ticketNR);
    set_t_WHTransfer(data.t_WHTransfer);
    set_t_WONumber(ticketData['repair-ticket'].wi_number);
    set_t_SONumber(ticketData.jobcard.order_number);
    set_t_GRNNumber(ticketData.jobcard.grn_number);
  }, [billingData]);

  useEffect(() => {
    checkBillingInfo(ticketData).then((data) => setBillingData(data));

    checkClock(relationId).then((data) => {
      setTimeData(data.data.value);
    });
  }, [ticketData]);

  const checkBillingInfo = async (arr) => {
    let data;
    if (arr['billing-note'][0] === undefined) {
      data = {
        billing_checked: true,
        jc_stamped: '',
        so_stamped: '',
        grn_used: '',
        hw_permit: '',
        COC: '',
        comp_sheet: '',
        WO: '',
        t_customerRating: 1,
        t_travelKM: '',
        t_travelTimeNT: '',
        t_travelTimeOT1: '',
        t_travelTimeOT2: '',
        s_invoiceStore: false,
        s_warrantee: false,
        s_claimSupplier: false,
        s_noCharge: false,
        s_reCall: false,
        t_accAndSnt: '',
        t_ticketNR: '',
        t_WHTransfer: '',
        t_QNumber: '',
        t_CONumber: '',
        t_INumber: '',
        t_IAmount: '',
        t_tripSplit1: '',
        t_tripSplit2: '',
      };
    } else {
      data = await arr['billing-note'][0];
    }
    return data;
  };

  const combineData = () => {
    let ticketBlob = {
      'repair-ticket': {
        ticket_type: ticketData['repair-ticket'].ticket_type,
        customer_id: ticketData['repair-ticket'].customer_id,
        status: ticketData['repair-ticket'].status,
        wi_number: t_WONumber,
      },
      'billing-note': [
        {
          billing_checked: true,
          jc_stamped: jc_stamped,
          so_stamped: so_stamped,
          grn_used: grn_used,
          hw_permit: hw_permit,
          COC: COC,
          comp_sheet: comp_sheet,
          WO: WO,
          t_customerRating: t_customerRating,
          t_travelKM: t_travelKM,
          t_travelTimeNT: t_travelTimeNT,
          t_travelTimeOT1: t_travelTimeOT1,
          t_travelTimeOT2: t_travelTimeOT2,
          s_invoiceStore: s_invoiceStore,
          s_warrantee: s_warrantee,
          s_claimSupplier: s_claimSupplier,
          s_noCharge: s_noCharge,
          s_reCall: s_reCall,
          t_accAndSnt: t_accAndSnt,
          t_ticketNR: t_ticketNR,
          t_WHTransfer: t_WHTransfer,
          t_QNumber: t_QNumber,
          t_CONumber: t_CONumber,
          t_INumber: t_INumber,
          t_IAmount: t_IAmount,
          t_tripSplit1: t_tripSplit1,
          t_tripSplit2: t_tripSplit2,
        },
      ],
      jobcard: {
        order_number: t_SONumber,
        grn_number: t_GRNNumber,
        stock_used: ticketData['jobcard'].stock_used,
        gas_type: ticketData['jobcard'].gas_type,
        gas_in: ticketData['jobcard'].gas_in,
        gas_out: ticketData['jobcard'].gas_out,
        notes: ticketData['jobcard'].notes,
      },
    };

    return ticketBlob;
  };

  const ticketUpdate = (ticketId) => {
    const DataBlob = { ...combineData() };
    //Get JWT from storage
    let JWT = localStorage.getItem('JWT_Key');
    //Set default Headers
    let headers = {
      'content-type': 'application/JSON',
    };
    //Set JWT in header if available
    if (JWT) {
      headers['x-api-key'] = JWT;
    }
    let body = {};
    body = DataBlob;
    const request = new Request(`${APIROOT}/api/repair-tickets/${ticketId}`, {
      method: 'post',
      headers,
      body: JSON.stringify(body),
    });
    fetch(request)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error(`Failed to save ticket`);
        }
      })
      .then((data) => {
        let parsed = JSON.parse(data);
        if (parsed.success === true) {
          setForceUpdate((val) => val + 1);
          //Update JWT if required
          if (parsed.JWT) {
            localStorage.setItem('JWT_Key', parsed.JWT);
          }

          //CLOSE HERE
          closeModal();
        } else {
          //Force logout
          if (parsed.message === 'Please login') {
            logout(() => {
              enqNotification('Session Expired', 'warning');
            });
          } else {
            enqNotification(parsed.message, 'error');
          }
        }
      })
      .catch((error) => {
        enqNotification(
          typeof error == 'string' ? error : `Connection Error !! ${error}`,
          'error'
        );
      });
  };

  const gasUsed = (
    parseFloat(ticketData.jobcard.gas_in) -
    parseFloat(ticketData.jobcard.gas_out)
  ).toFixed(2);

  const handleCheckList = (event) => {
    switch (event.target.id) {
      case 'jc_stamped':
        set_jc_stamped(event.target.value);
        break;
      case 'so_stamped':
        set_so_stamped(event.target.value);
        break;
      case 'grn_used':
        set_grn_used(event.target.value);
        break;
      case 'hw_permit':
        set_hw_permit(event.target.value);
        break;
      case 'COC':
        set_COC(event.target.value);
        break;
      case 'WO':
        set_WO(event.target.value);
        break;
      default:
        break;
    }
  };

  const handleSwitchList = (event) => {
    switch (event.target.id) {
      case 's_invoiceStore':
        set_s_invoiceStore(event.target.checked);
        set_s_warrantee(false);
        set_s_claimSupplier(false);
        set_s_noCharge(false);
        set_s_reCall(false);
        break;
      case 's_warrantee':
        set_s_invoiceStore(false);
        set_s_warrantee(event.target.checked);
        set_s_claimSupplier(false);
        set_s_noCharge(false);
        set_s_reCall(false);
        break;
      case 's_claimSupplier':
        set_s_invoiceStore(false);
        set_s_warrantee(false);
        set_s_claimSupplier(event.target.checked);
        // set_s_noCharge(false);
        // set_s_reCall(false);
        break;
      case 's_noCharge':
        set_s_invoiceStore(false);
        set_s_warrantee(false);
        // set_s_claimSupplier(false);
        set_s_noCharge(event.target.checked);
        // set_s_reCall(false);
        break;
      case 's_reCall':
        set_s_invoiceStore(false);
        set_s_warrantee(false);
        // set_s_claimSupplier(false);
        // set_s_noCharge(false);
        set_s_reCall(event.target.checked);
        break;
      default:
        break;
    }
  };

  const handle_t_Input = (event) => {
    switch (event.target.id) {
      case 'jc_stamped':
        set_jc_stamped(event.target.value);
        break;
      case 'so_stamped':
        set_so_stamped(event.target.value);
        break;
      case 'grn_used':
        set_grn_used(event.target.value);
        break;
      case 'hw_permit':
        set_hw_permit(event.target.value);
        break;
      case 'COC':
        set_COC(event.target.value);
        break;
      case 'WO':
        set_WO(event.target.value);
        break;

      case 'comp_sheet':
        set_comp_sheet(event.target.value);
        break;
      case 't_customerRating':
        set_t_customerRating(event.target.value);
        break;
      case 't_travelKM':
        set_t_travelKM(event.target.value);
        break;
      case 't_travelTimeNT':
        set_t_travelTimeNT(event.target.value);
        break;
      case 't_travelTimeOT1':
        set_t_travelTimeOT1(event.target.value);
        break;
      case 't_travelTimeOT2':
        set_t_travelTimeOT2(event.target.value);
        break;
      case 't_accAndSnt':
        set_t_accAndSnt(event.target.value);
        break;
      case 't_ticketNR':
        set_t_ticketNR(event.target.value);
        break;
      case 't_WHTransfer':
        set_t_WHTransfer(event.target.value);
        break;
      case 'WONumber':
        set_t_WONumber(event.target.value);
        break;
      case 'SOT':
        set_t_SONumber(event.target.value);
        break;
      case 'GRNNumber':
        set_t_GRNNumber(event.target.value);
        break;

      case 't_QNumber':
        set_t_QNumber(event.target.value);
        break;
      case 't_CONumber':
        set_t_CONumber(event.target.value);
        break;
      case 't_INumber':
        set_t_INumber(event.target.value);
        break;
      case 't_IAmount':
        set_t_IAmount(event.target.value);
        break;
      case 't_tripSplit1':
        set_t_tripSplit1(event.target.value);
        break;
      case 't_tripSplit2':
        set_t_tripSplit2(event.target.value);
        break;
      default:
        break;
    }
  };

  const helpChecklist = [
    {
      id: 'jc_stamped',
      title: 'Job Card Stamped & Signed:',
      value: jc_stamped,
    },
    {
      id: 'so_stamped',
      title: 'Store Order Stamped & Signed:',
      value: so_stamped,
    },
    { id: 'grn_used', title: 'GRN Number Used:', value: grn_used },
    { id: 'hw_permit', title: 'Hot Work Permit:', value: hw_permit },
    { id: 'COC', title: 'COC:', value: COC },
    // {
    //   id: 'comp_sheet',
    //   title: 'Compressor Data Sheet:',
    //   value: comp_sheet,
    // },
    // { id: 'WO', title: 'WO:', value: WO },
  ];

  const helpChecklist2 = [
    {
      id: 'comp_sheet',
      title: 'Compressor Data Sheet:',
      value: comp_sheet,
    },
  ];
  const helpChecklist3 = [{ id: 'WO', title: 'WO:', value: WO }];

  const ratingList = [
    {
      id: 't_customerRating',
      title: 'Customer Rating:',
      value: t_customerRating === undefined || null ? '' : t_customerRating,
      itemType: 'number',
      minNum: 1,
      maxNum: 5,
      numStep: 1,
    },
  ];

  //Need to be handled with time and attendance
  const labourList = [
    {
      id: 'LabHrsNT',
      title: 'Labour Hrs. NT:',
      value:
        timeData.nt_minutes.toFixed(2) === undefined || null
          ? 0
          : timeData.nt_minutes.toFixed(2),
    },
    {
      id: 'LabHrsOT1',
      title: 'Labour Hrs. OT1:',
      value:
        timeData.ot1_minutes.toFixed(2) === undefined || null
          ? 0
          : timeData.ot1_minutes.toFixed(2),
    },
    {
      id: 'LabHrsOT2',
      title: 'Labour Hrs. OT2:',
      value:
        timeData.ot2_minutes.toFixed(2) === undefined || null
          ? 0
          : timeData.ot2_minutes.toFixed(2),
    },
  ];

  const travelList = [
    {
      id: 't_travelKM',
      title: 'Travel KM:',
      value: t_travelKM,
      itemType: 'number',
      minNum: 0,
      maxNum: 1000,
      numStep: 0.25,
    },
    {
      id: 't_travelTimeNT',
      title: 'Travel Time NT:',
      value: t_travelTimeNT,
      itemType: 'number',
      minNum: 0,
      maxNum: 1000,
      numStep: 0.25,
    },
    {
      id: 't_travelTimeOT1',
      title: 'Travel Time. OT1:',
      value: t_travelTimeOT1,
      itemType: 'number',
      minNum: 0,
      maxNum: 1000,
      numStep: 0.25,
    },
    {
      id: 't_travelTimeOT2',
      title: 'Travel Time. OT2:',
      value: t_travelTimeOT2,
      itemType: 'number',
      minNum: 0,
      maxNum: 1000,
      numStep: 0.25,
    },
  ];

  const switchList = [
    { id: 's_invoiceStore', title: 'Invoice Store:', value: s_invoiceStore },
    { id: 's_warrantee', title: 'Warrantee:', value: s_warrantee },
    {
      id: 's_claimSupplier',
      title: 'Claim Supplier:',
      value: s_claimSupplier,
    },
    {
      id: 's_noCharge',
      title: 'No Charge:',
      value: s_noCharge,
    },
    {
      id: 's_reCall',
      title: 'Re-Call:',
      value: s_reCall,
    },
  ];

  const accAndSnt = [
    { id: 't_ticketNR', title: 'Ticket NR.', value: t_ticketNR },
    { id: 't_accAndSnt', title: 'Acc & Snt', value: t_accAndSnt },
  ];

  const gasList = [
    {
      id: 'gasType',
      title: 'Type',
      value: ticketData.jobcard?.gas_type?.name ?? 'No Gas Used',
    },
    { id: 'gasKG', title: 'KG', value: `${gasUsed === 'NaN' ? '0' : gasUsed}` },
  ];

  const stockAndConsum =
    ticketData.jobcard.stock_used === undefined
      ? []
      : ticketData.jobcard.stock_used;

  const billingInfo1 = [
    { id: 't_WHTransfer', title: 'WareHouseTransfer:', value: t_WHTransfer },
  ];
  const billingInfo2 = [
    {
      id: 'WONumber',
      title: 'WO Number:',
      value: t_WONumber,
    },
    {
      id: 'SOT',
      title: 'Store Order Number:',
      value: t_SONumber,
    },
    {
      id: 'GRNNumber',
      title: 'GRN Number:',
      value: t_GRNNumber,
    },
  ];

  const billingInfo3 = [
    { id: 't_QNumber', title: 'Quote Number:', value: t_QNumber },
    { id: 't_CONumber', title: 'Capex Order Number:', value: t_CONumber },
    { id: 't_INumber', title: 'Invoice Number:', value: t_INumber },
    { id: 't_IAmount', title: 'Invoice/Cost Amount:', value: t_IAmount },
  ];

  const billingInfo4 = [
    { id: 't_tripSplit1', title: 'Trip Split Ticket', value: t_tripSplit1 },
    { id: 't_tripSplit2', title: '', value: t_tripSplit2 },
  ];

  const blockIitem = (
    type,
    title,
    value,
    itemType,
    minNum,
    maxNum,
    numStep
  ) => {
    switch (type) {
      case 'check':
        return (
          <Checkbox
            key={title}
            id={title}
            name={title}
            checked={value}
            onChange={handleCheckList}
          />
        );
      case 'info':
        return (
          <Typography
            key={title}
            id={title}
            name={title}
          >{`${value}`}</Typography>
        );
      case 'input':
        return (
          <TextField
            key={title}
            id={title}
            size='small'
            name={title}
            onChange={handle_t_Input}
            type={itemType}
            inputProps={{
              step: numStep,
              min: minNum,
              max: maxNum,
            }}
            value={value}
            style={{
              background:
                value === undefined || value === '' || value === null
                  ? '#00334433'
                  : 'none',
              width: '100%',
            }}
          />
        );
      case 'switch':
        return (
          <Stack direction='row' spacing={1} alignItems='center' checked={true}>
            <Typography>No</Typography>
            <Switch
              onChange={handleSwitchList}
              key={title}
              id={title}
              name={title}
              checked={value}
            />
            <Typography>Yes</Typography>
          </Stack>
        );
      default:
        break;
    }
  };

  const createListItems = (arr, type) => {
    let style =
      type === 'info'
        ? {
            background: '#none',
            border: 'solid 2px #354775',
            paddingLeft: '5px',
            display: 'flex',
            alignItems: 'center',
            // justifyContent: 'center',
          }
        : { display: 'flex', alignItems: 'center' };
    return (
      <>
        {arr.map((list) => (
          <Grid container xs={12} md={12} key={list.id} height='40PX'>
            <Grid
              item
              xs={8}
              lg={8}
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <Typography align='left' style={ticketTypoTitle}>
                {list.title}
              </Typography>
            </Grid>
            <Grid item xs={4} lg={4} style={style}>
              {blockIitem(
                type,
                list.id,
                list.value,
                list.itemType,
                list.minNum,
                list.maxNum,
                list.numStep
              )}
            </Grid>
          </Grid>
        ))}
      </>
    );
  };

  return (
    <Box
      // backgroundColor='#eeeeff'
      padding={1}
      style={{
        display: 'block',
        overflow: 'scroll',
        height: '80vh',
        width: '100%',
      }}
    >
      <Box align='right'>
        {' '}
        <Button onClick={props.closeModel}>X</Button>
      </Box>
      <Grid
        container
        xs={12}
        md={12}
        flexDirection='row'
        rowGap={1}
        columnGap={6}
        alignContent='flex-start'
      >
        <Grid
          container
          xs={12}
          md={4}
          flexDirection='row'
          rowGap={1}
          // columnGap={1}
          alignContent='flex-start'
        >
          <Grid item xs={12} lg={12}>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              Helpdesk Checklist
            </Typography>
            <Divider />
          </Grid>
          {createListItems(helpChecklist, 'input')}
          {createListItems(helpChecklist2, 'input')}
          {createListItems(helpChecklist3, 'input')}
          {createListItems(ratingList, 'input')}
          <Divider />
          <Grid item xs={12} lg={12}>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              Customer Notes on Job Card
            </Typography>
            <Divider />
          </Grid>

          <Grid
            item
            xs={12}
            lg={12}
            style={{
              background: '#none',
              border: 'solid 2px #354775',
              paddingLeft: '5px',
            }}
          >
            <Typography style={ticketTypoInfo} minHeight={40}>
              {`${ticketData.jobcard.notes}` === 'undefined'
                ? ' '
                : `${ticketData.jobcard.notes}`}
            </Typography>
          </Grid>
          <Grid item xs={12} lg={12}>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              Communication Notes
            </Typography>
            <Divider />
          </Grid>
          <Grid
            item
            xs={12}
            lg={12}
            style={{
              border: 'solid 2px #354775',
              background: '#none',
              // border: 'solid 2px #354775',
              // paddingLeft: '5px',
              padding: '1px',
              paddingTop: '-2px',
            }}
          >
            <GlobalNotes
              relationId={ticketData['repair-ticket'].id}
              relationType='ticketTable'
            />
          </Grid>
        </Grid>
        <Grid
          container
          xs={12}
          md={7}
          flexDirection='row'
          rowGap={1}
          // columnGap={1}
          alignContent='flex-start'
        >
          <Grid item xs={12} lg={12}>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              {props.ticketData.ticket_num}
            </Typography>
            <Divider />
          </Grid>
          {createListItems(labourList, 'info')}
          {createListItems(travelList, 'input')}
          {createListItems(switchList, 'switch')}
          {createListItems(accAndSnt, 'input')}
          <Grid item xs={12} lg={12}>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              Gas
            </Typography>
            <Divider />
          </Grid>
          {createListItems(gasList, 'info')}
          <Grid item xs={12} lg={12}>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              Stock & Consumables
            </Typography>
            <Divider />
          </Grid>
          <TableContainer>
            <Table
              sx={{ minWidth: 650 }}
              size='small'
              aria-label='a dense table'
            >
              <TableHead>
                <TableRow>
                  <TableCell>QTY</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Stock Code</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {stockAndConsum.map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{
                      '&:last-child td, &:last-child th': { border: 0 },
                      '&:row:nth-child(2)': { background: 'red' },
                    }}
                  >
                    <TableCell component='th' scope='row'>
                      {row.qty}
                    </TableCell>
                    <TableCell>{row.description}</TableCell>
                    <TableCell>{row.code}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Divider />
          </TableContainer>
          {createListItems(billingInfo1, 'input')}
          {createListItems(billingInfo2, 'input')}
          {createListItems(billingInfo3, 'input')}
          {createListItems(billingInfo4, 'input')}
        </Grid>
      </Grid>
      <Box align='right' style={{ padding: '15px' }}>
        <Button variant='contained' onClick={() => ticketUpdate(ticketID)}>
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default BillingNoteRepair;

async function checkClock(ticketId) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };
  if (JWT) {
    headers['x-api-key'] = JWT;
  }
  let body = {
    fetch: 'ticket_hours_repair',
    fetchid: ticketId,
  };
  const request = new Request(`${APIROOT}/api/actions`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });
  const response = await fetch(request);

  const data = response.json();
  return data;
}
